export function assertError(msg) {
    throw new Error(`Internal error: ${msg}`);
}
